import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31f8a23a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f8a23a')) {
      api.createRecord('31f8a23a', component.options)
    } else {
      api.reload('31f8a23a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31f8a23a", function () {
      api.rerender('31f8a23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sale/index.vue"
export default component.exports